import { useState, useContext, useEffect } from "react";
import { ref, onValue, query, orderByChild } from "firebase/database";
import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import { realTimeDB } from "../../firebase";
import { AuthContext } from "../../contexts/AuthContext";
import constants from "../../utils/constants";

const { REALTIME_DB_NAME } = constants;

const useFetchPersonalChat = (receiverUid) => {
  const { currentUser } = useContext(AuthContext);
  const uid = get(currentUser, "uid", "");

  const [isLoading, setIsLoading] = useState(false);
  const [isGotResponse, setIsGotResponse] = useState(false);
  const [response, setResponse] = useState([]);

  const fetchPersonalChat = async () => {
    setIsLoading(true);
    setIsGotResponse(false);

    const chatRoom =
      "chat_" +
      (uid < receiverUid ? uid + "_" + receiverUid : receiverUid + "_" + uid);
    const topUserPostsRef = query(
      ref(realTimeDB, `${REALTIME_DB_NAME.CHAT_PERSONAL}/` + chatRoom),
      orderByChild("createdAt")
    );

    onValue(topUserPostsRef, (snapshot) => {
      let records = [];
      snapshot.forEach((childSnapshot) => {
        const keyName = childSnapshot.key;
        const data = childSnapshot.val();
        records.push({ customKey: keyName, ...data });
      });

      if (!isEmpty(records)) {
        setResponse(records);
        setIsGotResponse(true);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    });
  };

  useEffect(() => {
    if (uid) {
      fetchPersonalChat();
    }
  }, [receiverUid]);

  return { isLoading, isGotResponse, response };
};

export default useFetchPersonalChat;
